export const DOCS_REQUEST = "DOCS_REQUEST";
export const DOCS_SUCCESS = "DOCS_SUCCESS";
export const DOCS_FAILURE = "DOCS_FAILURE";